import React, { useState, useEffect } from 'react';
import "./TermsAndConditions.css";
import SalesTologyFooter from '../SalesTologyFooter/SalesTologyFooter';
import Navbar from '../Navbar/Navbar';

// Terms and Conditions Component
const TermsAndConditions = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Navbar />
    <div className="service-container" style={{ marginTop: '80px' }}>
      <div className="service-header">Terms And Conditions</div>
      <div className={`terms-content ${isVisible ? 'visible' : ''}`}>
        <div className="terms-text">
          <p className="terms-welcome">
            Welcome to SalesTology. By accessing our website (https://www.salestology.com/), you agree to the following terms and conditions.
          </p>

          <div className="terms-section">
            <h3 className="terms-section-title">1. Use of Website</h3>
            <ul className="terms-list">
              <li className="terms-list-item">The content is for informational purposes only.</li>
              <li className="terms-list-item">You agree to use the website lawfully and not engage in unauthorized activities.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3 className="terms-section-title">2. Intellectual Property</h3>
            <ul className="terms-list">
              <li className="terms-list-item">All content on this website is owned by SalesTology and protected by copyright laws.</li>
              <li className="terms-list-item">Unauthorized use, reproduction, or distribution is prohibited.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3 className="terms-section-title">3. Limitation of Liability</h3>
            <ul className="terms-list">
              <li className="terms-list-item">We strive for accuracy but do not guarantee it. We are not liable for any damages arising from the use of our website.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3 className="terms-section-title">4. Third-Party Links</h3>
            <ul className="terms-list">
              <li className="terms-list-item">We may link to third-party websites but are not responsible for their content or policies.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3 className="terms-section-title">5. Privacy Policy</h3>
            <ul className="terms-list">
              <li className="terms-list-item">Your use of the website is subject to our Privacy Policy.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3 className="terms-section-title">6. Changes to Terms</h3>
            <ul className="terms-list">
              <li className="terms-list-item">We may update these terms without prior notice. Continued use of the site implies acceptance.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3 className="terms-section-title">7. Contact Us</h3>
             <ul className="terms-list">
              <li className="terms-list-item"> For questions, contact us at{' '}
              <a href="mailto:ankit.sharma@salestology.com" className="terms-link">
                zuheir.shahwan@salestology.com
              </a></li>
            </ul>
          </div>
        </div>
      </div>
  
    </div>
    <SalesTologyFooter />
    </>
  );
};

export default TermsAndConditions;